import { cn } from "@/lib/utils";
import { CheckCircleIcon, XCircleIcon, InformationCircleIcon, ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import { ToastContentProps } from "react-toastify";

interface ToastData {
  title: string;
  content?: string;
  type?: "success" | "error" | "info" | "warning" | "default";
}

function CustomToastComponent({ data }: ToastContentProps<ToastData>) {
  const toastData = {
    ...data,
    type: data.type || "default"
  };

  function GetIcon(type: string) {
    switch (type) {
    case "success":
      return <CheckCircleIcon className="w-5 h-5 text-green-500" />;
    case "error":
      return <XCircleIcon className="w-5 h-5 text-red-500" />;
    case "info":
      return <InformationCircleIcon className="w-5 h-5 text-blue-500" />;
    case "warning":
      return <ExclamationTriangleIcon className="w-5 h-5 text-yellow-500" />;
    }
  }

  function GetTitleColor(type: string) {
    switch (type) {
    case "success":
      return "text-green-500";
    case "error":
      return "text-red-500";
    case "info":
      return "text-blue-500";
    case "warning":
      return "text-yellow-500";
    case "default":
      return "text-slate-800";
    }
  }

  return (
    <div className="flex flex-col gap-1" data-cy="custom-toast-component">
      <div className="flex items-center">
        {toastData.type !== "default" && (
          <div className="mr-2">
            {GetIcon(toastData.type)}
          </div>
        )}
        <h3 className={cn("text-sm font-semibold", GetTitleColor(toastData.type))}>{toastData.title}</h3>
      </div>
      <p className={cn("text-sm text-slate-600", toastData.type !== "default" && "pl-7")}>{toastData.content}</p>
    </div>
  );
}

export default CustomToastComponent;
